import { Injectable } from '@angular/core';
import { ComponentItem } from 'src/app/common/models/component-item.interface';
import { FormField } from 'src/app/common/models/form-details.model';
import { FORM_FIELD_TYPE } from '../../defines/defines';
import { FIELD_TYPE_TEMPLATES } from 'src/config/field-type-templates-config';
import { TranslateService } from '@ngx-translate/core';

/** ComponentLoaderService */
@Injectable({
  providedIn: 'root',
})
export class ComponentLoaderService {
  /**
   * @param TranslateService ts
   */
  public constructor (public ts: TranslateService) {}

  /** dynamicComponents */
  public dynamicComponents = new Array<ComponentItem>();

  /** configureDynamicComponents
   * @method configureDynamicComponents
   * @param {FormDetails} formDetails
   * @description function to prepare the configuration for each dynamic component
   */
  public configureDynamicComponents (formFields: FormField[]) {
    this.dynamicComponents = [];
    for (const formField of formFields) {
      if (!formField.hide) {
        const fieldType = formField.type;
        const component = new ComponentItem(FIELD_TYPE_TEMPLATES[fieldType], formField);

        /** add label for radio button as subheadline component h4 */
        if (fieldType === FORM_FIELD_TYPE.RADIO && formField.items && formField.items.length !== 0 ) {
          if (formField.label) {
            const optional = this.ts.instant('FromCenterModule.formRendering.optionalField.std-headline');
            const labelComponent = new ComponentItem(
              FIELD_TYPE_TEMPLATES.subheadline,
              {
                value: formField.required ? formField.label + '*' : formField.label + ' ' + optional,
                type: FORM_FIELD_TYPE.SUBHEADLINE,
              },
            );
            this.dynamicComponents.push(labelComponent);
          }
        }
        this.dynamicComponents.push(component);
      }
    }
  }
}
